import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    connectToken: '',
    loginToken: '',
  },
  mutations:{
    setLoginToken(state, value) {
      state.loginToken = value
    },
    setConnectToken(state, value) {
      state.connectToken = value
    },
  },
  getters:{
    getConnectToken: state => state.connectToken,
    getLoginToken: state => state.loginToken,
  }
})
